var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_5678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9108 14.9819C18.4508 16.0004 18.2308 16.4557 17.64 17.3557C16.8146 18.6127 15.6492 20.1811 14.2085 20.1919C12.9269 20.2027 12.5962 19.3557 10.8569 19.3696C9.11769 19.3781 8.75538 20.2073 7.47231 20.1942C6.03154 20.1811 4.92846 18.7681 4.10231 17.5134C1.79231 13.9942 1.54846 9.86959 2.97615 7.67498C3.98615 6.11882 5.58461 5.20498 7.08538 5.20498C8.61384 5.20498 9.57461 6.04498 10.8385 6.04498C12.0646 6.04498 12.8115 5.20267 14.5792 5.20267C15.9162 5.20267 17.33 5.93113 18.34 7.18805C15.0354 8.99882 15.5723 13.7188 18.9108 14.9819ZM13.2377 3.79805C13.8808 2.97267 14.3685 1.80805 14.1915 0.620361C13.1423 0.6919 11.9154 1.3619 11.1985 2.22959C10.5492 3.01959 10.0108 4.19344 10.2208 5.32882C11.3654 5.36575 12.55 4.68344 13.2377 3.79805Z",
    fill: "#02405D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_5678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.407227)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.f544a1910162347d297bc37d78a28065.svg";
export { ForwardRef as ReactComponent };